(function () {
  let customerPopup = document.querySelector(".login-popup");

  let customerLogin = customerPopup?.querySelector(".customer__login__popup");
  let customerForgotPassword = customerPopup?.querySelector(
    ".customer__forgot-pass__popup"
  );
  let customerRegister = customerPopup?.querySelector(".customer__register__popup");

  const returnToInput = customerPopup?.querySelector('input[name="return_to"]');

  const checkValidation = function (element) {
    const $fields = [...element.querySelectorAll("input")];
    const $invalid_fields = $fields.filter(($field) => !$field.checkValidity());

    $fields.forEach(($field) => {
      $field.value = $field.value.trim();

      if ($field.checkValidity()) {
        $field.classList.remove("is-invalid");
        $field.removeAttribute("aria-invalid");
      }
    });

    if ($invalid_fields.length === 0) {
      return true;
    }

    $invalid_fields.forEach(($field) => {
      $field.classList.add("is-invalid");
      $field.setAttribute("aria-invalid", true);
    });

    $invalid_fields[0].focus();
    return false;
  };

  const forgotLinkCancel = customerForgotPassword?.querySelector(
    ".forgot-pass__cancel"
  );

  if (forgotLinkCancel && customerPopup)
    forgotLinkCancel?.addEventListener("click", function (e) {
      e.preventDefault();
      location.hash = "#login";
      customerForgotPassword?.classList.remove("customer__page--form--active");
      customerLogin?.classList.add("customer__page--form--active");
      customerRegister?.classList.remove("customer__page--form--active");
    });

  const showPasses = customerPopup?.querySelectorAll(".show-password");

  showPasses?.forEach((showPass) =>
    showPass.addEventListener("click", function () {
      const input = this.parentNode.querySelector("input");
      if (input.type === "password") {
        input.type = "text";
        this.querySelector(".show-password__cta").innerHTML = "Hide";
      } else {
        input.type = "password";
        this.querySelector(".show-password__cta").innerHTML = "View";
      }
    })
  );

  function submitLogin(event) {
    customerEmail = customerLogin?.querySelector("#login-popup-email");
    customerPassword = customerLogin?.querySelector("#login-popup-password");
    var email = customerEmail?.value;
    var password = customerPassword?.value;

    if (!checkValidation(customerLogin)) {
      return;
    }
    var query = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
          customerAccessTokenCreate(input: $input) {
              customerAccessToken {
                  accessToken
                  expiresAt
              }
              customerUserErrors {
                  code
                  field
                  message
              }
          }
      }
  `;

    var variables = {
      input: {
        email: email,
        password: password,
      },
    };

    fetch("/api/2022-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token":
          "4ca11ef70f0b00cf85b80f8f81cd9630",
      },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          data.errors ||
          data.data.customerAccessTokenCreate.customerUserErrors.length > 0
        ) {
          customerLogin?.querySelector("#login-popup-error")
            .classList.remove("hidden");
          customerEmail?.setAttribute("aria-invalid", "true");
          customerPassword?.setAttribute("aria-invalid", "true");
        } else {
          localStorage.setItem(
            "customerAccessToken",
            data.data.customerAccessTokenCreate.customerAccessToken
              .accessToken
          );
          let action_url = "/account/login";
          if (returnToInput.value != "")
            action_url += "?return_to=" + returnToInput.value;
          customerLogin?.querySelector("#customer_login")
            .setAttribute("action", action_url);
          customerLogin?.querySelector("#customer_login").submit();
        }
      })
      .catch((error) => {
        customerLogin?.querySelector("#login-popup-error")
          .classList.remove("hidden");
        customerEmail?.setAttribute("aria-invalid", "true");
        customerPassword?.setAttribute("aria-invalid", "true");
      });
  }

  customerLogin?.querySelector("#login-popup-password").addEventListener("keydown", function(event){
    if (event.isComposing || event.keyCode === 13) {
      submitLogin()
      return;
    }
  })

  customerLogin?.querySelector("button.submit")
    .addEventListener("click", submitLogin);

  customerForgotPassword?.querySelector("button.submit")
    .addEventListener("click", function (event) {
      customerEmail = customerForgotPassword?.querySelector(
        "#recover-popup-email"
      );
      var email = customerEmail?.value;
      if (!checkValidation(customerForgotPassword)) {
        return;
      }
      var query = `
        mutation customerRecover($email: String!) {
          customerRecover(email: $email) {
            customerUserErrors {
              code
              field
              message
            }
          }
        }
      `;

      var variables = {
        email: email,
      };

      fetch("/api/2022-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "4ca11ef70f0b00cf85b80f8f81cd9630",
        },
        body: JSON.stringify({ query: query, variables: variables }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (
            data.errors ||
            data.data.customerRecover.customerUserErrors.length > 0
          ) {
            customerForgotPassword?.querySelector("#recover-popup-error")
              .classList.remove("hidden");
            customerEmail?.setAttribute("aria-invalid", "true");
          } else {
            customerForgotPassword?.querySelector("#recover-success")
              .classList.remove("hidden");
            customerForgotPassword?.querySelector("#recover_customer")
              .classList.add("hidden");
          }
        })
        .catch((error) => {
          customerForgotPassword?.querySelector("#recover-popup-error")
            .classList.remove("hidden");
          customerEmail?.setAttribute("aria-invalid", "true");
        });
    });

  customerRegister?.querySelector("a.submit")
    .addEventListener("click", function (event) {
      let action_url = "/account/login";
      action_url += "?return_to=/account?view=rewards";
      customerRegister?.querySelector("#create_customer")
        .setAttribute("action", action_url);
      customerRegister?.querySelector("#create_customer").submit();
    });

  customerRegister?.querySelector("button.create-user")
    .addEventListener("click", function (event) {
      event.preventDefault();
      customerFirstName = customerRegister?.querySelector(
        "#register-popup-first-name"
      );
      customerLastName = customerRegister?.querySelector(
        "#register-popup-last-name"
      );
      customerEmail = customerRegister?.querySelector("#register-popup-email");
      customerPassword = customerRegister?.querySelector(
        "#register-popup-password"
      );
      customerSubscribe = customerRegister?.querySelector(
        "#register-popup-subscribe"
      );
      var email = customerEmail?.value;
      var password = customerPassword?.value;
      var firstName = customerFirstName?.value;
      var lastName = customerLastName?.value;
      var acceptsMarketing = customerSubscribe?.checked;

      if (!checkValidation(customerRegister)) {
        return;
      }

      var query = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer {
            acceptsMarketing
            email
            displayName
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
  `;

      var variables = {
        input: {
          email,
          password,
          firstName,
          lastName,
          acceptsMarketing,
        },
      };

      fetch("/api/2022-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "4ca11ef70f0b00cf85b80f8f81cd9630",
        },
        body: JSON.stringify({ query: query, variables: variables }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (
            data.errors ||
            data.data.customerCreate.customerUserErrors.length > 0
          ) {
            if (data.errors) {
              let errorMsg = "";
              data.errors?.forEach((error) => {
                errorMsg += error?.message + "<br/>";
              });
              customerRegister.querySelector(
                ".register-failed-alert"
              ).innerHTML = errorMsg;
              customerRegister?.querySelector(".register-failed-alert")
                .classList.remove("hidden");
            } else {
              data.data.customerCreate?.customerUserErrors?.forEach((error) => {
                if (error.code === "TAKEN") {
                  customerRegister?.querySelector(".existing-email-alert")
                    .classList.remove("hidden");
                  customerRegister?.querySelector("#create_customer")
                    .classList.add("hidden");
                  setTimeout(() => {
                    location.hash = "#login";
                    setTimeout(() => {
                      customerLogin.querySelector("#login-popup-email").value =
                        email;
                      customerLogin?.querySelector("#login-popup-password")
                        .focus();
                    }, 300);
                  }, 5000);
                }
              });
            }
          } else {
            customerRegister.querySelector(".customer-first-name").innerHTML =
              firstName;
            customerRegister?.querySelector(".register-success-alert")
              .classList.remove("hidden");
            customerRegister?.querySelector("#create_customer")
              .classList.add("hidden");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
})();
